import { CommonModule } from '@angular/common';
import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-tab',
  imports: [CommonModule],
  template: ``,
  styles: ``,
})
export class TabComponent {
  /**
   * Label for the tab
   */
  @Input()
  label: string;

  @Input()
  routerLink: string;

  /**
   * Optional unique key for the tab. If value is null, label becomes value.
   */
  @Input()
  value: string;

  @Input()
  count = 0;

  @Input()
  visible = true;

  /**
   * Label for the tab
   */
  @Input()
  icon: string;

  @ContentChild('content')
  contentTemplate: TemplateRef<any>;

  get computedValue(): string {
    return this.value ?? this.label;
  }
}
